import React, { Component } from "react";
import { Metric, Error } from "./../../Utils/Utils.js";
import Heading from "./../../Elements/Heading";

class Donations extends Component {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row pt-3">

        <div className="col-auto mr-auto mb-4">
          <Heading size={6} className={'mb-1'}>
            Total Closed Donations
          </Heading>
          <Metric {...data.total} type="currency" size={"lg"} />
        </div>

        <div className="col-auto mr-auto mb-4">
          <Heading size={6} className={'mb-1'}>
            Avg Donation Per Person
          </Heading>
          <Metric {...data.average} type="currency" size={"lg"} />
        </div>

        <div className="col-auto mr-auto mb-4">
          <Heading size={6} className={'mb-1'}>
            People Who Donated
          </Heading>
          <Metric {...data.count} size={"lg"} />
        </div>
      </div>
    );
  }
}

export default Donations;
